import React, { ReactNode } from "react";
import styles from "./ButtonFooter.module.css";
import { Button } from "../Button";
import { sendMessage } from "../../../context/utils";

export const ButtonFooter = ({
  children,
  showNote = false,
}: {
  children?: ReactNode;
  showNote?: boolean;
}) => {
  const onCancel = () => {
    sendMessage({ status: "ERROR" });
  };
  return (
    <div className={styles.container}>
      {children}
      <div className={styles.cancelBtnMobile}>
        <Button
          type="button"
          text="Cancel"
          buttonStyle="cancel"
          onClick={onCancel}
        />
      </div>
    </div>
  );
};
